<template>
  <footer :class="['mainFooter', { 'mainFooter--home': isHomepage, 'mainFooter--page': isPage }]">
    <div class="mainFooter__inner container">
      <!--      <div class="mainFooter__logo">-->
      <!--        <nuxt-link to="/">-->
      <!--          <logo />-->
      <!--        </nuxt-link>-->
      <!--      </div>-->
      <div class="mainFooter__content">
        <div class="mainFooter__nav">
          <div v-for="(col, colIndex) in menu" :key="colIndex" class="mainFooter__navCol">
            <div @click="toggle($event)" class="mainFooter__title">
              {{ col.title }}
            </div>
            <div class="mainFooter__navColContent">
              <ul class="mainFooter__navColList">
                <li
                  v-for="(colItem, colItemIndex) in col.items"
                  :key="colItemIndex"
                  class="mainFooter__navColItem"
                >
                  <nuxt-link
                    v-if="colItem.to"
                    :to="colItem.to"
                    class="mainFooter__navColLink"
                    :rel="colItem.rel"
                  >
                    {{ colItem.title }}
                  </nuxt-link>
                  <a v-else :href="colItem.href" :rel="colItem.rel" class="mainFooter__navColLink">
                    {{ colItem.title }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="mainFooter__contact mainFooter__navCol">
            <div @click="toggle($event)" class="mainFooter__title">KONTAKT I OBSŁUGA</div>
            <div class="mainFooter__navColContent">
              <a href="mailto:info@ofix.pl" class="mainFooter__contactMail">
                <div class="mainFooter__contactIcon icon-letter" />
                info@ofix.pl
              </a>
              <a href="tel:801 800 801" class="mainFooter__contactNumber">
                <div class="mainFooter__contactIcon mainFooter__contactNumberIcon" />
                <div>
                  801 800 801<br />
                  <span class="mainFooter__contactNumberText">opłata 0,29zł netto/min</span>
                </div>
              </a>
              <table class="mainFooter__contactTable">
                <tbody>
                  <tr>
                    <th>pon. - pt.</th>
                    <td>8:00 - 16:00</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mainFooter__contactSocials">
              <a
                href="https://www.facebook.com/Ofixpl"
                target="_blank"
                class="mainFooter__contactSocial"
                rel="nofollow"
              >
                <span class="icon-facebook" />
              </a>
              <a
                href="https://www.linkedin.com/company/ofix-pl-office-depot-business-partner/"
                target="_blank"
                class="mainFooter__contactSocial"
                rel="nofollow"
              >
                <span class="icon-linkedin" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCCiv8uMwfAtDmRAI9l3pXlw"
                target="_blank"
                class="mainFooter__contactSocial"
                rel="nofollow"
              >
                <span class="icon-youtube" />
              </a>
            </div>
            <div id="0024bc7c-abf2-4652-a680-c247c78296b8"></div>
            <div class="mainFooter__trusmate">
              <div id="a3ca20bd-e2e6-47b0-84ab-00351e49af8d"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainFooter__logotypes">
        <footer-logotypes :logotypes="logotypes" />
      </div>
      <div class="mainFooter__content">
        <div class="mainFooter__copy">
          <nuxt-link to="/polityka-prywatnosci" rel="nofollow">Polityka Prywatności</nuxt-link>
          | &copy; 2020 by ofix.pl. Wszystkie prawa zastrzeżone.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Logo from '~/components/Logo';
import FooterLogotypes from '@/components/FooterLogotypes';

export default {
  name: 'MainFooter',
  components: {
    FooterLogotypes,
    Logo,
  },
  data() {
    return {
      logotypes: [
        {
          src: '/images/footer/medal.png',
          alt: 'EcoVadis Sustainability Rating 2024',
          width: '177',
          height: '140',
        },
        {
          src: '/images/footer/FORBES_diamenty2024.png',
          alt: 'Diamenty Miesięcznika Forbes 2021',
          width: '177',
          height: '140',
        },
        {
          src: '/images/footer/Gazele_2024_logo-RGBpincet-min.png',
          alt: 'Gazele biznesu 2021',
          width: '244',
          height: '70',
        },
        {
          src: '/images/footer/certyfikat.png',
          alt: 'Certyfikat',
          width: '244',
          height: '70',
        },
        {
          src: '/images/footer/przelewy24_logo_2022.svg',
          alt: 'przelewy 24',
          width: '200',
          height: '70',
        },
        {
          src: '/images/footer/inpost.svg',
          alt: 'Inpost',
          width: '116',
          height: '70',
        },
        {
          src: '/images/footer/GLS_Logo_2021_RGB_GLSBlue.png',
          alt: 'Inpost',
          width: '260',
          height: '70',
        },
        {
          src: '/images/footer/dpd.svg',
          alt: 'Inpost',
          width: '152',
          height: '70',
        },
      ],
      menu: [
        {
          title: 'MOJE KONTO',
          items: [
            {
              to: '/logowanie',
              title: 'Zaloguj',
              rel: 'nofollow',
            },
            {
              to: '/moj-ofix/zamowienia',
              title: 'Moje zamówienia',
              rel: 'nofollow',
            },
            {
              to: this.$auth.isLogged ? '/moj-ofix/lista' : '/lista-zakupowa',
              title: 'Lista produktowa',
              rel: 'nofollow',
            },
            {
              to: '/moj-ofix/oferty',
              title: 'Strefa ofert',
              rel: 'nofollow',
            },
          ],
        },
        {
          title: 'POMOC',
          items: [
            {
              href: 'https://pomoc.ofix.pl/',
              title: 'Centrum pomocy',
              rel: 'nofollow',
            },
            {
              to: '/sposoby-platnosci',
              title: 'Sposoby płatności',
              rel: 'nofollow',
            },
            {
              to: '/zwroty-i-reklamacje',
              title: 'Zwroty i reklamacje',
              rel: 'nofollow',
            },
            {
              to: '/warunki-dostaw',
              title: 'Warunki dostaw',
              rel: 'nofollow',
            },
            {
              to: '/regulamin-sklepu',
              title: 'Regulamin sklepu',
              rel: 'nofollow',
            },
          ],
        },
        {
          title: 'OFIX',
          items: [
            {
              href: 'https://ofix.zohorecruit.eu/jobs/Careers',
              title: 'Kariera',
              rel: 'nofollow',
            },
            {
              href: 'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=PL',
              title: 'ODR',
              rel: 'nofollow',
            },
            {
              to: '/blog',
              title: 'Blog',
            },
            {
              to: '/promocje',
              title: 'Promocje',
              rel: 'nofollow',
            },
            {
              to: '/kontakt',
              title: 'Kontakt',
              rel: 'nofollow',
            },
          ],
        },
      ],
    };
  },
  computed: {
    isHomepage() {
      let name = '';
      if (this.$nuxt.$route.name) {
        name = this.$nuxt.$route.name.split('___')[0];
      }

      return name === 'index' || name === 'contact';
    },
    isPage() {
      let name = '';
      if (this.$nuxt.$route.name) {
        name = this.$nuxt.$route.name.split('___')[0];
      }

      return name === 'slug';
    },
  },
  mounted() {
    this.$helper.loadScript(
      'https://trustmate.io/widget/api/0024bc7c-abf2-4652-a680-c247c78296b8/script',
      'trustmate-script-sticky',
    );
    this.$helper.loadScript(
      'https://trustmate.io/widget/api/a3ca20bd-e2e6-47b0-84ab-00351e49af8d/script',
      'trustmate-script-footer',
    );
  },
  methods: {
    toggle(e) {
      e.currentTarget.toggleClass('mainFooter__title--active');
      const target = e.currentTarget.nextElementSibling;
      target.toggleClass('mainFooter__navColContent--active');
      if (target.hasClass('mainFooter__navColContent--active')) {
        target.style.maxHeight = `${target.scrollHeight}px`;
      } else {
        target.style.maxHeight = 0;
      }
    },
  },
};
</script>

<style lang="scss">
.mainFooter {
  background-color: $cWhite;
  margin-top: 10rem;
  padding-top: 7rem;
  padding-bottom: 4rem;

  @include rwd('ultra') {
    margin-top: 7rem;
    padding-top: 5rem;
  }

  @include rwd('tablet') {
    margin-top: 6rem;
    padding-top: 4rem;
    padding-bottom: 3rem;
  }

  &--home {
    background-color: $cBg;

    @include rwd('ultra') {
      margin-top: 10rem;
      padding-top: 7rem;
    }

    @include rwd('tablet') {
      margin-top: 0;
      background-color: $cWhite;
    }
  }

  &--page {
    border: 1px solid #e6e6e6;
    margin-top: 0 !important;
  }

  // &--grey {
  //   background-color: $cBg;
  //   margin-top: 0;
  // }

  &__inner {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__logo {
    flex: 0 0 20%;
    max-width: 20%;

    @include rwd('large-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
      margin-bottom: 1.3rem;
    }

    @include rwd('small-tablet') {
      text-align: center;
    }
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    flex: 0 0 80%;
    max-width: 80%;
    margin-top: 2.5rem;

    @include rwd('large-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }

    @include rwd('small-tablet') {
      border-top: 1px solid $cAddLight;
    }
  }

  &__title {
    position: relative;
    display: inline-block;
    padding-bottom: 2.2rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    letter-spacing: 0.07em;
    font-weight: 700;
    transition: color $tr;

    @include rwd('small-tablet') {
      display: flex;
      justify-content: space-between;
      padding-bottom: 2rem;
      padding-top: 2rem;
      font-size: 1.2rem;
      line-height: 1.5rem;

      &:after {
        position: absolute;
        top: 50%;
        transform: translateY(-50%) rotate(0);
        right: 1.3rem;
        @include icomoon('chevron-down');
        font-size: 0.7rem;
        color: $cMainLight;
        transition: transform $tr;
      }
    }

    &--active {
      @include rwd('small-tablet') {
        &:after {
          transform: translateY(-50%) rotate(180deg);
        }
      }
    }
  }

  &__nav {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    flex: 0 0 100%;
    max-width: 100%;

    @include rwd('tablet') {
      justify-content: unset;
    }
  }

  &__navCol {
    flex: 0 0 25%;
    max-width: 25%;

    @include rwd('tablet') {
      flex: 0 0 50%;
      max-width: 50%;
      margin-bottom: 4rem;
    }

    @include rwd('small-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
      margin-bottom: 0;
    }

    &--contact {
      flex: 0 0 28%;
      max-width: 28%;

      @include rwd('tablet') {
        flex: 0 0 50%;
        max-width: 50%;
      }

      @include rwd('small-tablet') {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }

  &__navColContent {
    @include rwd('small-tablet') {
      max-height: 0;
      overflow: hidden;
      border-bottom: 1px solid $cAddLight;
      transition: max-height $tr;
    }
  }

  &__navColList {
    @include rwd('small-tablet') {
      padding-bottom: 2rem;
    }
  }

  &__navColLink {
    position: relative;
    display: inline-block;
    font-size: 1.6rem;
    line-height: 3rem;
    color: $cAddDark02;
    transition: padding-left $tr, color $tr;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 2px;
      width: 0;
      background-color: $cSec;
      transition: width $tr;
    }

    &:hover {
      padding-left: 1.5rem;
      color: $cSec;

      &:before {
        width: 1rem;
      }
    }
  }

  &__contact {
    max-width: 200px;

    @include rwd('small-tablet') {
      max-width: 100%;
    }
  }

  &__contactMail,
  &__contactNumber {
    display: flex;
    margin-bottom: 2rem;
    align-items: center;
    font-family: $fSecond;
    font-size: 2.4rem;
    line-height: 1.8rem;
    font-weight: 500;
    transition: color $tr;

    @include rwd('large-tablet') {
      font-size: 2rem;
      line-height: 2.6rem;
    }

    &:hover {
      color: $cSec;
    }
  }

  &__contactNumberText {
    font-size: 1.2rem;
    line-height: 1;
    font-weight: 400;
  }

  &__contactTable {
    font-size: 1.4rem;
    line-height: 2.2rem;

    @include rwd('small-tablet') {
      margin-bottom: 2rem;
    }

    th {
      text-align: left;
      padding-right: 1.2rem;
      color: $cAddDark02;
    }

    td {
      color: $cMainDark;
    }
  }

  &__contactSocials {
    margin-top: 2.6rem;
    margin-left: -0.9rem;
    margin-right: -0.9rem;

    @include rwd('small-tablet') {
      text-align: center;
      margin-top: 4rem;
    }
  }

  &__contactSocial {
    font-size: 1.7rem;
    color: $cAddDark02;
    padding: 0.9rem;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }

  &__contactIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2rem;
    width: 2.8rem;
    height: 2.8rem;
    border-radius: 50%;
    background-image: linear-gradient(180deg, #ffac77 0%, #ff6e00 100%);
    background-color: $cSec;
    font-size: 1.4rem;
    line-height: 1.4rem;
    color: $cWhite;
  }

  &__contactNumberIcon {
    &:before {
      @include icomoon('phone-filled');
    }
  }

  &__copy {
    margin-top: 3rem;
    font-size: 1.4rem;
    line-height: 3rem;
    color: $cAddDark02;

    @include rwd('tablet') {
      margin-top: 1.4rem;
    }

    @include rwd('small-tablet') {
      text-align: center;
      font-size: 1.3rem;
      line-height: 2rem;
    }

    a {
      border-bottom: 1px solid $cAddDark;
      transition: color $tr, border $tr;

      &:hover {
        color: $cSec;
        border-bottom: 1px solid $cSec;
      }
    }
  }

  &__logotypes {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 0 0 88%;
    max-width: 88%;
    margin-top: 1rem;

    @include rwd('laptop') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  &__trusmate {
    margin-top: 1rem;
    height: 57px;

    @include rwd('small-tablet') {
      .tm-dodo2 {
        margin: 0 auto;
      }
    }
  }
}
</style>
